module.exports = __webpack_public_path__ + "fonts/K1laq2fH.woff";